import { DefaultProps } from '../types/default'

const DEFAULT: DefaultProps = {
    api: {
        endpoint: process.env.REACT_APP_API_HOST,
        countryCode: process.env.REACT_APP_API_COUNTRY_CODE,
        project: process.env.REACT_APP_API_PROJECT
    },
    project: {
        baseHref: process.env.PUBLIC_URL || '',
        googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS,
        googleReCaptcha: process.env.REACT_APP_GOOGLE_RECAPTCHA_PUBLIC,
        chat: process.env.REACT_APP_CHAT,
        couriers: process.env.REACT_APP_COURIERS 
                    ? JSON.parse(process.env.REACT_APP_COURIERS)
                    : []
    }
}

export default DEFAULT
